export default __webpack_public_path__ + "static/media/rootsvandrern.980214da.jpg";